// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean, number, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementFeatureFlagRolloutUpsertResult = objectOf({
  rollout: objectOf({
    id: string,
    app_group_id: string,
    segments_data_array: arrayOf(
      arrayOf(
        objectOf({
          id: string,
          name: string,
          app_group_id: string,
          is_archived: boolean,
          is_global_control: boolean,
        })
      )
    ),
    filters: arrayOf(any),
    core_rollout: objectOf({
      rollout_id: string,
      rollout_nst: string,
      feature_flag_name: string,
      feature_flag_description: string,
      feature_flag_send_percentage: number,
      feature_flag_id: string,
      feature_flag_properties: string,
      feature_flag_enabled: boolean,
    }),
    is_archived: boolean,
    created_by: string,
    last_edited: string,
    last_edited_by_id: string,
    tag_names: arrayOf(string),
    territory_ids: arrayOf(any),
  }),
});
